<style lang="scss" scoped>
    .pipe_board {
        margin-left: -15px;
        margin-right: -15px;
    }

    .board {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        overflow-x: scroll;
        min-height: 150px;
        height: 100%;
        overflow-y: hidden;
        padding: 0 5px 6px;

        &::-webkit-scrollbar-thumb {
            background-color: #bbb;

            &:hover {
                background-color: #aaa;
            }
        }

        .list {
            min-width: 280px;
            width: 280px;
            -webkit-box-flex: 0;
            -webkit-flex: none;
            -ms-flex: none;
            flex: none;
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -webkit-flex-direction: column;
            -ms-flex-direction: column;
            flex-direction: column;
            margin-right: 2px;

            .list_header {
                padding: 10px 35px 10px 10px;
                position: relative;
                background-color: #f4f8fb;
                color: #4c5667;
                font-size: 12px;
                font-weight: 600;
                text-transform: uppercase;
                width: calc(100% - 6px);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                border: 1px solid rgba(54, 64, 74, 0.1);
                border-radius: 3px;

                > .label-inverse {
                    position: absolute;
                    right: 6px;
                    top: 10px;
                    padding: 4px 5px;
                    text-transform: none;
                }
            }

            .list_body {
                overflow-y: scroll;
                min-height: 350px;
                height: calc(100vh - 197px);
                padding: 0 2px 0;
            }
        }

        .add_lead_pipe {
            width: calc(100% - 6px);
            background: #f9f9f9;
            margin-bottom: 3px;
            box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0);

            &:hover,
            &:focus {
                box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
            }
        }
    }

</style>

<template>
	<master-layout>

        <!-- Breadcamb -->
		<div class="row">
			<div class="col-xs-12 col-sm-6 col-md-4">
				<div class="select_custom_pipeline m-b-5">
                    <span class="icon_select" v-pml-tooltip.bottom-right="$t('pipeline')"><i class="md-dashboard"></i></span>
                    <pml-select v-model="pipeline_id" :options="pipelines"></pml-select>
                </div>
			</div>
            <div class="col-xs-12 col-sm-6 col-md-4">
                <div class="select_custom_pipeline m-b-5" v-if="member.is_admin">
                    <span class="icon_select" v-pml-tooltip.bottom-right="$t('consultant')"><i class="md-headset-mic"></i></span>
                    <pml-select-members v-model="member_id" :options="members()" label="full_name" :onlyActive="true"></pml-select-members>
                </div>
            </div>
			<div class="col-xs-12 col-sm-12 col-md-4 t_right">
				<div class="clearfix m-b-5">
                    <span @click.prevent.stop="show_filter = !show_filter" class="btn-sm btn btn_green" v-if="pipelines.length">
                        <span class="btn-label">
                            <i class="fa fa-search"></i>
                        </span>
                        {{ $t('filter_advanced') }}
                    </span>
                    <a @click.prevent="fetch" class="btn-sm btn btn-warning" v-pml-tooltip.bottom="$t('refresh')"><i class="fa fa-refresh"></i></a>
					<a href="javascript:history.back();" class="btn btn-white"><i class="fa fa-chevron-circle-left m-r-5"></i> {{ $t('back') }}</a>
				</div>
			</div>
		</div>

        <!-- Alert Move  -->
        <div class="alert alert-warning alert-dismissible fade in m-b-5" role="alert" v-if="this.member_id === '' || this.member_id === null">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
            <strong>{{ $t('attention') }}!</strong> {{ $t('select_consultant_to_move_pipeline_card') }}
        </div>

        <!-- Filter -->
        <div class="card-box m-b-5 p-b-10" v-if="pipelines.length && show_filter">
            <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-3 m-b-15">
                    <label>{{ $t('source') }}</label>
                    <pml-multiselect v-model="sources_id" :options="sources" label="name"></pml-multiselect>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-3 m-b-15">
                    <label>{{ $t('segment') }}</label>
                    <pml-multiselect v-model="segments_id" :options="segments" label="name"></pml-multiselect>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-3 m-b-15">
                    <label>{{ $t('perception') }}</label>
                    <pml-multiselect v-model="perceptions_id" :options="perceptions" label="name"></pml-multiselect>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-3 m-b-15">
                    <label>{{ $t('status') }} <small class="text-muted">({{ $t('deal') }})</small></label>
                    <pml-select v-model="status_id" :options="deal_status" label="name"></pml-select>
                </div>
            </div>
        </div>

        <!-- Init Pipeline -->
        <div class="row" v-if="showDemo">
            <div class="col-sm-12 col-md-7">
                <img src="/static/images/pipeline.gif" alt="Cards Pipeline" class="img-responsive">
            </div>
            <div class="col-sm-12 col-md-5 t_center" v-if="canCreate">
                <div class="card-box p-30 m-t-20">
                    <div class="row">
                        <div class="col-md-offset-1 col-md-10">
                            <h3><i class="md-dashboard f_size_30"></i></h3>
                            <h3 class="bold">
                                <span class="show">{{ $t('pipeline') }}</span>
                            </h3>
                            <h4 class="m-b-20">{{ $t('organize_your_work_with_pipeline') }}</h4>
                            <div class="alert alert_default t_center" v-if="!member.is_admin">
                                <p>{{ $t('ask_admin_to_create_pipeline') }}</p>
                            </div>
                            <router-link :to="{ name: 'pipelines.index' }" class="btn btn-default" v-if="member.is_admin">
                                <span class="btn-label">
                                    <i class="fa fa-plus-circle fa-fw"></i>
                                </span>
                                {{ $t('pipeline') }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Kanban -->
        <div class="bg_load_null pipe_board" v-pml-block="isLoading">
            <div class="board">
                <div class="list" v-if="pipeline_id !== null" v-for="step in pipeline.steps">
                    <div class="list_header">
                        {{ step.name }}
                        <span class="label label-inverse" v-pml-tooltip.left="$t('deals')">{{ data[step.id].length }}</span>
                    </div>
                    <button class="btn btn-white btn-block text-uppercase bold f_size_11 add_lead_pipe" @click.prevent="createDeal(step.id)"><i class="fa fa-plus m-r-5"></i>{{ $t('deal') }}</button>
                    <vue-draggable :id="step.id" v-if="member_id !== null" :list="lists[step.id]" class="list_body" @start="isDragging = true" @end="updateOrder($event)" :options="dragOptions">
                        <PmlCard v-for="(item) in lists[step.id]" :item="item" :key="item.id" :selectedMember="member_id"></PmlCard>
                        <PmlInfiniteLoading @infinite="infiniteHandler($event, step.id)" :ref="'infiniteLoading' + step.id" spinner="wavedots">
                            <span slot="no-more"></span>
                            <span slot="no-results"></span>
                            <span v-if="lists[step.id].length === data[step.id].length" slot="spinner"></span>
                        </PmlInfiniteLoading>
                    </vue-draggable>
                    <div v-else :list="lists[step.id]" class="list_body">
                        <PmlCard v-for="(item) in lists[step.id]" :item="item" class="drag_none" :key="item.id"></PmlCard>
                        <PmlInfiniteLoading @infinite="infiniteHandler($event, step.id)" :ref="'infiniteLoading' + step.id" spinner="wavedots">
                            <span slot="no-more"></span>
                            <span slot="no-results"></span>
                            <span v-if="lists[step.id].length === data[step.id].length" slot="spinner"></span>
                        </PmlInfiniteLoading>
                    </div>
                </div>
                <div v-else>
                    <p class="t_center m-t-30"><i class="fa fa-exclamation-triangle"></i> {{ $t('select_pipeline') }}</p>
                </div>
            </div>
        </div>

    </master-layout>
</template>

<script>
    import PmlInfiniteLoading from 'vue-infinite-loading'
    import Notify from 'utils/helpers/notify'
    import PmlCard from './Card.vue'
    import { trans } from 'utils/helpers/translation'
    import { getKanban, sort } from 'services/deals'
    import { findPipeline } from 'utils/helpers/find-store'
    import { mapGetters } from 'vuex'
    import { groupBy, orderBy, isNil, map, find, flatten, forEach, isNull, includes } from 'lodash'

    export default {
        name: 'KanbanView',
        components: {
            PmlCard,
            PmlInfiniteLoading
        },
        data () {
            return {
                pipeline_id: null,
                show_filter: false,
                member_id: null,
                lists: {},
                data: {},
                isLoading: false,
                isDragging: false,
                delayedDragging: false,
                status_id: '',
                perceptions_id: [],
                sources_id: [],
                segments_id: []
            }
        },
        metaInfo () {
            return {
                title: trans('pipeline')
            }
        },
        mounted () {
            this.initFiltersStorage()
            if (!this.member.is_admin || this.member_id === null)
                this.member_id = this.member.id
            this.status_id = (isNull(this.status_id) || this.status_id === '') ? 'open' : this.status_id
        },
        computed: {
            ...mapGetters({
                'members': 'getActiveMembers',
                'member': 'getMember',
                'pipelines': 'getPipelines',
                'sources': 'getSources',
                'segments': 'getSegments',
                'perceptions': 'getDealPerceptions',
                'tenant': 'getTenant',
                'deal_status': 'getDealStatus'
            }),
            pipeline () {
                return findPipeline(this.pipeline_id) || {steps: []}
            },
            dragOptions () {
                return {
                    animation: 0,
                    group: 'description',
                    ghostClass: 'ghost'
                }
            },
            showDemo () {
                return this.pipelines.length === 0 || this.pipeline_id === null
            },
            canCreate () {
                return this.pipelines.length >= 3 && ['premium_power_sales'].includes(this.tenant.stripePlan)
            }
        },
        watch: {
            '$route' () {
                this.fetch()
            },
            'pipeline_id' (val) {
                window.localStorage.setItem('pml_last_pipeline_kanban', val)
                this.fetch()
            },
            'pipeline' (val) {
                this.setUnusedColumns(val.steps)
            },
            'member_id' (val) {
                window.localStorage.setItem('pml_last_member_id_kanban', val)
                this.fetch()
            },
            'status_id' (val) {
                window.localStorage.setItem('pml_last_deal_status_kanban', val)
                this.fetch()
            },
            'sources_id' (val) {
                window.localStorage.setItem('pml_last_sources_kanban', val)
                this.fetch()
            },
            'perceptions_id' (val) {
                window.localStorage.setItem('pml_last_perceptions_kanban', val)
                this.fetch()
            },
            'segments_id' (val) {
                window.localStorage.setItem('pml_last_segments_kanban', val)
                this.fetch()
            },
            'isDragging' (newValue) {
                if (newValue) {
                    this.delayedDragging = true
                    return
                }
                this.$nextTick(() => { this.delayedDragging = false })
            }
        },
        methods: {
            fetch () {
                if (isNil(this.pipeline_id) || isNull(this.pipeline_id)) return

                this.isLoading = true
                let params = {
                    kanban_view: this.pipeline_id,
                    member_id: this.member_id,
                    status: this.status_id,
                    perceptions: this.perceptions_id,
                    sources: this.sources_id,
                    segments: this.segments_id
                }
                getKanban(this.pipeline_id, params)
                    .then(response => {
                        this.data = groupBy(orderBy(response.data, ['pipeline_step_order']), 'pipeline_step_id')
                        this.setUnusedColumns(this.pipeline.steps)
                        forEach(this.pipeline.steps, (item) => {
                            this.loadLists(item.id)
                            this.$nextTick(() => {
                                if (typeof this.$refs['infiniteLoading' + item.id][0] !== 'undefined')
                                    this.$refs['infiniteLoading' + item.id][0].$emit('$InfiniteLoading:reset')
                            })
                        })
                    })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isLoading = false })
            },
            setUnusedColumns (steps) {
                forEach(steps, (item) => {
                    if (typeof this.data[item.id] === 'undefined')
                        this.data[item.id] = []

                    this.$set(this.lists, item.id, [])
                })
            },
            updateOrder ($event) {
                let stepTo = $event.to.id
                let stepFrom = $event.from.id
                let newId = $event.newIndex
                let oldId = $event.oldIndex
                if (typeof this.lists[stepTo][newId] !== 'undefined')
                    this.data[stepTo].splice(newId, 0, this.lists[stepTo][newId])
                else if (typeof this.lists[stepTo][newId - 1] !== 'undefined')
                    if (this.lists[stepTo][newId - 1].id === this.data[stepFrom][oldId].id)
                        this.data[stepTo].splice(newId - 1, 0, this.lists[stepTo][newId - 1])

                this.data[stepFrom].splice([oldId], 1)

                let obj = map(this.lists, (item, index) => {
                    let stepId = index
                    return map(item, (deal) => {
                        return {
                            id: deal.id,
                            pipeline_step_id: stepId
                        }
                    })
                })

                this.isDragging = false

                sort({ items: flatten(obj) })
                    .catch(() => Notify.error(trans('_notifications.error')))
            },
            initFiltersStorage () {
                this.checkStorage('pml_last_pipeline_kanban', 'pipelines', 'pipeline_id')
                this.checkStorage('pml_last_deal_status_kanban', 'deal_status', 'status_id')
                this.checkStorage('pml_last_perceptions_kanban', 'perceptions', 'perceptions_id', 'array')
                this.checkStorage('pml_last_sources_kanban', 'sources', 'sources_id', 'array')
                this.checkStorage('pml_last_segments_kanban', 'segments', 'segments_id', 'array')
                if (this.member.is_admin)
                    this.checkStorage('pml_last_member_id_kanban', 'members', 'member_id')
            },
            checkStorage (path, collection, field, type = null) {
                let last = window.localStorage.getItem(path)

                if (typeof last === 'undefined' || isNull(last)) return

                let result
                if (type === 'array') {
                    last = map(last.split(','), (item) => parseInt(item) || item)
                    result = find(this[collection], (item) => {
                        return includes(last, item.id)
                    })
                } else {
                    last = parseInt(last) || last
                    result = find(this[collection], {id: last})
                }

                if (typeof result !== 'undefined')
                    this[field] = last || null
                else
                    window.localStorage.removeItem(path)
            },
            infiniteHandler ($state, step) {
                setTimeout(() => {
                    this.loadLists(step)
                    $state.loaded()
                    if (this.lists[step].length === this.data[step].length)
                        $state.complete()
                }, 1000)
            },
            loadLists (stepId, amount = 15) {
                let listsLen = this.lists[stepId].length
                let dataLen = this.data[stepId].length

                if (listsLen + amount > dataLen)
                    this.lists[stepId] = this.lists[stepId].concat(this.data[stepId].slice(listsLen, dataLen))
                else
                    this.lists[stepId] = this.lists[stepId].concat(this.data[stepId].slice(listsLen, listsLen + amount))
            },
            createDeal (stepId) {
                window.sessionStorage.setItem('pipeline_action_pipeline_id', stepId)
                this.$router.push({ name: 'deals.create' })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/pipeline/components/Main.vue